module.exports = __webpack_public_path__ + "img/351.038f06be.png";